const eldX_reseller = window.$environment.RESELLER;

const routeConfigs = [
  {
    url: eldX_reseller + '/registration',
    component: 'Registration',
    title: 'Registration',
    layout: 'plain',
    module: 'registration'
  },
  {
    url: eldX_reseller + '/login',
    component: 'Login',
    title: 'Login',
    layout: 'login',
    module: 'login'
  },  
  {
    url: '/privacy-policy',
    component: 'PrivacyPolicyScreen',
    layout: 'plain',
    module: 'privacyPolicyScreen',
    title: 'Privacy Policy'
  },
  {
    url: '/',
    component: 'ELDXUnhandled',
    title: 'ELD X',
    layout: 'login',
    module: 'login'
  },
  {
    url: eldX_reseller + '/',
    component: 'Login',
    title: 'Login',
    layout: 'login',
    module: 'login'
  },
  {
    url: eldX_reseller + '/auth/recovery',
    component: 'ForgotPassword',
    title: 'Forgot Password',
    layout: 'login',
    module: 'recovery'
  },
  {
    url: eldX_reseller + '/feedback',
    component: 'Feedback',
    title: 'Feedback',
    module: 'feedback'
  },
  {
    url: eldX_reseller + '/user/resetPassword',
    component: 'ResetPassword',
    layout: 'welcome',
    module: 'resetPassword',
    title: 'Reset Password'
  },
  {
    url: eldX_reseller + '/user/mfa',
    component: 'MFA',
    layout: 'login',
    module: 'MFAPage',
    title: 'MFA'
  }
];

export default routeConfigs;
